import axiosInstance from '../../../helpers/backend_helper';

const updateEpisode = async ({id, ...others}) => {
  try {
    const formData = new FormData();
    Object.keys(others)
      .forEach(key => {
        formData.append(key, others[key])
      })

    const response = await axiosInstance.post(`episodes/update/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error updating episode:', error);
    throw error;
  }
};

export default updateEpisode;
